export const LOTTERIES = {
  Powerball: {
    key: "Powerball",
    name: "Powerball",
    mainCount: 5,
    mainMin: 1,
    mainMax: 69,
    bonusName: "Powerball",
    bonusMin: 1,
    bonusMax: 26,
  },
  MegaMillions: {
    key: "MegaMillions",
    name: "Mega Millions",
    mainCount: 5,
    mainMin: 1,
    mainMax: 70,
    bonusName: "Mega Ball",
    bonusCount: 1,
    bonusMin: 1,
    bonusMax: 24,
  },
};